import { Alert, CircularProgress, Stack, Table, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import type { TestEmailCheck, TestEmailResult } from "./testEmailResult";

interface Props {
  result: TestEmailResult;
}

const getCheckColor = (check: TestEmailCheck): "success" | "error" | undefined => {
  if (check.ok === undefined) {
    return undefined;
  }
  return check.ok ? "success" : "error";
};

const TestEmailResultAlert = ({ result }: Props) => (
  <Alert severity={result.severity} icon={result.finished ? undefined : <CircularProgress size="1.25rem" />}>
    <Stack spacing={1}>
      <Typography>{result.summary}</Typography>
      {result.checks.length > 0 && (
        <Table>
          <TableBody>
            {result.checks.map((check) => (
              <TableRow key={check.label}>
                <TableCell>{check.label}</TableCell>
                <TableCell>
                  <Typography color={getCheckColor(check)}>{check.value}</Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Stack>
  </Alert>
);

export default TestEmailResultAlert;
